import { SET_PAGE_ALIAS } from '../actions/types';

export default function pageAlias(state = '', action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_PAGE_ALIAS:
				return action.payload;
			default:
				return state;
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/pageAlias.js